import { CommonModule } from '@angular/common';

import { NgModule } from '@angular/core';
import { ListComponent } from './list-container/list.component';
import { ListItemDetailComponent } from './list-item-detail/list-item-detail.component';
import { ListItemComponent } from './list-item/list-item.component';




@NgModule({
  declarations: [
    ListComponent,
    ListItemComponent,
    ListItemDetailComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    ListComponent,
    ListItemComponent,
    ListItemDetailComponent
  ]
})
export class ListModule { }
